import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../Skeleton';
import styles from './Input.module.scss';

const Input = ({
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  type = 'text',
  name,
  maxLength,
  charLimit,
  required = false,
  disabled = false,
  error = false,
  errorMessage = '',
  helperText = '',
  isLoading = false,
  className = '',
  inputClassName = '',
  ...rest
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value, e.target.name, e);
    }
  };

  const inputClasses = [
    styles.input,
    error && styles.error,
    inputClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`${styles.inputWrapper} ${className}`}>
      {(label || charLimit) && (
        <div className={styles.labelRow}>
          {label && (
            <label className={styles.label} htmlFor={name}>
              {label}
              {required && <span className={styles.required}>*</span>}
            </label>
          )}
          {charLimit && (
            <span className={styles.charLimit}>
              {typeof charLimit === 'string' ? charLimit : `Max ${charLimit} characters`}
            </span>
          )}
        </div>
      )}
      <div className={styles.inputContainer}>
        {isLoading ? (
          <Skeleton height="40px" borderRadius="8px" />
        ) : (
          <input
            id={name}
            name={name}
            type={type}
            value={value}
            onChange={handleChange}
            onBlur={onBlur}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            className={inputClasses}
            aria-invalid={error}
            aria-describedby={
              error && errorMessage ? `${name}-error` : helperText ? `${name}-helper` : undefined
            }
            {...rest}
          />
        )}
      </div>
      {error && errorMessage && (
        <div id={`${name}-error`} className={styles.errorMessage}>
          {errorMessage}
        </div>
      )}
      {!error && helperText && (
        <div id={`${name}-helper`} className={styles.helperText}>
          {helperText}
        </div>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  charLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  helperText: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
};

export default Input;
